<template>
    <b-container class="py-4" style="position:relative">
        <b-row>
            <b-col class="text-center">
                
                <h6>Set Unit Scale</h6>
                <p class="text-muted text-caption">
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <label><small>Enter Line Length ({{ unit.label }})</small></label>
                    <b-input placeholder="Enter number" v-model="unitScale.length"/> 
                </b-form-group>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-right">
                <b-btn variant="outline-dark" size="sm" @click="__close_drawer()">ANNULER</b-btn>
                <b-btn 
                    class="ml-2" size="sm" 
                    variant="primary" :disabled="loading"
                    @click="submitHandler()"
                >
                    SUBMIT
                    <b-spinner v-if="loading" small label="Loading..."></b-spinner>
                </b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import {ModalMixin, ProjectMixin} from '@/mixins'
import { mapGetters } from 'vuex'
export default {
    name: "UnitScaleModal",
    mixins: [ModalMixin, ProjectMixin],
    computed: {
        ...mapGetters({
            'project' : 'projects/item'
        }),
        unitScale: {
            get(){
                return this.$store.getters['canvas/unitScale']
            },
            set(unitScale){
                this.$store.commit('canvas/unitScale',unitScale)
            }
        }
    },
    data(){
        return {
            loading: false,
            unitType: 'meter',
            unitTypes: [
                {
                    value: "meter",
                    text: "Meter (mts)"
                },
                {
                    value: "feet",
                    text: "Feet (ft)"
                },
                
            ]
        };
    },
    methods:{
        submitHandler(){
            this.loading = true
            let scale = this.unitScale.length / this.unitScale.pixel
            this.$store.dispatch('projects/update',{
                id: this.project.id,
                payload: {
                    project: {
                        scale: scale
                    }
                }
            }).then(()=>{
                this.$store.dispatch('projects/find', {id: this.project.id})
                this.__close_drawer()
                this.$eventbus.$emit('close-toast')
            }).finally(()=>{
                this.loading = false
            })
        }
    }
    
}
</script>
<style>
    .modal-file-upload-input{
        position:absolute; 
        top: 0; 
        left: 0; 
        width:100%; 
        height: 100%;
        opacity: 0;
        z-index: 10;
    }
</style>